<script setup>
  import { computed } from 'vue';
  import HomeCoverPhoto from '@/components/HomeCoverPhoto.vue';
  import HomeCommunity from '@/components/HomeCommunity.vue';
  import HomeFeature from '@/components/HomeFeature.vue';
  import ModalSiteSettings from '@/components/ModalSiteSettings.vue';
  import ModalBrandPromo from '@/components/ModalBrandPromo.vue';
  import { useHomeStore } from '@/stores/HomeStore';
  import { useUserStore } from '@/stores/UserStore';
  import useSettingsGlobals from '@/composables/useSettingsGlobals';

  const { $PROMO_MODAL_ALLOWED } = useSettingsGlobals();

  const homeStore = useHomeStore();
  const userStore = useUserStore();

  const showPromoModal = computed(() => userStore.messages && userStore.messages.length > 0 && parseInt(userStore.nonTrialMemberLevel) < 49 && $PROMO_MODAL_ALLOWED);

  homeStore.loadCoverPhoto();
  homeStore.loadTestimonial();
</script>

<template>
  <HomeCoverPhoto :photo="homeStore.coverPhoto" variant="top" />

  <HomeCommunity />

  <HomeCoverPhoto :photo="homeStore.coverPhoto" variant="mid" />

  <HomeFeature :featureId="homeStore.featureId" />

  <Suspense>
    <ModalSiteSettings :show="userStore.showSettingsModal" />
  </Suspense>
  <ModalBrandPromo v-if="showPromoModal" />
</template>

<style>
#home {
  display: flex;
  flex-direction: column;
}
</style>
